import { SemanticICONS } from "semantic-ui-react";
import {
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_ADVISOR,
    USER_ROLE_INSTALLER,
    USER_ROLE_LOGISTIC,
    USER_ROLE_ORDERS,
    USER_ROLE_SOCIAL_MEDIA
} from "../utils/constants";

export interface MenuItem {
    key: string;
    as: string;
    icon: SemanticICONS;
    content: string;
    href?: string;
    active?: boolean;
}

export const ROLE_MENUS: Record<string, MenuItem[]> = {
    [USER_ROLE_SOCIAL_MEDIA]: [
        { key: 'prospects', as: 'a', icon: 'users', content: 'Prospectos', href: '/prospects' },
    ],
    [USER_ROLE_ADVISOR]: [
        { key: 'in-tracing', as: 'a', icon: 'hourglass half', content: 'En seguimiento', href: '/in-tracing' },
        { key: 'assignments', as: 'a', icon: 'clipboard list', content: 'Asignaciones', href: '/assignments' },
        { key: 'completed', as: 'a', icon: 'check circle', content: 'Completados', href: '/completed' },
        { key: 'orders', as: 'a', icon: 'box', content: 'Ordenes', href: '/orders' },
    ],
    [USER_ROLE_INSTALLER]: [
        { key: 'orders', as: 'a', icon: 'box', content: 'Ordenes', href: '/orders' },
    ],
    [USER_ROLE_LOGISTIC]: [
        { key: 'orders', as: 'a', icon: 'box', content: 'Ordenes', href: '/orders' },
        { key: 'reminders', as: 'a', icon: 'bell', content: 'Recordatorio anticipado', href: '/reminders' },
        { key: 'unfinished', as: 'a', icon: 'exclamation triangle', content: 'Proyectos inconclusos', href: '/unfinished' },
        { key: 'adjustments', as: 'a', icon: 'wrench', content: 'Ajustes y Garantias', href: '/guarantees/adjustments' },
    ],
    [USER_ROLE_ORDERS]: [
        { key: 'requests', as: 'a', icon: 'truck', content: 'Pedidos', href: '/requests' },
        { key: 'orders', as: 'a', icon: 'box', content: 'Ordenes', href: '/orders' },
        { key: 'reminders', as: 'a', icon: 'bell', content: 'Recordatorio anticipado', href: '/reminders' },
    ],
    [USER_ROLE_ADMINISTRATOR]: [
        { key: 'dashboard', as: 'a', icon: 'dashboard', content: 'Dashboard', href: '/' },
        { key: 'requests', as: 'a', icon: 'truck', content: 'Pedidos', href: '/requests' },
        { key: 'orders', as: 'a', icon: 'box', content: 'Ordenes', href: '/orders' },
        { key: 'reminders', as: 'a', icon: 'bell', content: 'Recordatorio anticipado', href: '/reminders' },
        { key: 'guarantees', as: 'a', icon: 'shield alternate', content: 'Todos los ajustes', href: '/guarantees' },
        { key: 'products', as: 'a', icon: 'shopping cart', content: 'Productos', href: '/products' },
        { key: 'users', as: 'a', icon: 'users', content: 'Usuarios', href: '/users' },
    ],
};
